import { useRef, useState, type MouseEvent } from 'react';
import { type ICustomer } from '@recargas-dominicanas/core/types';
import { Cell, CellIcon, Menu, Table, TableRow, TableHeader } from '@recargas-dominicanas/core/components';
import { MenuOption } from '../../../components/menu-option/menu-option.component';
import { style } from './customer-user.module.css';
import { EditModal } from './edit-modal/edit-modal.component';
import { CustomerModal } from './customer-modal/customer-modal.component';
import { ResetPasswordModal } from './reset-password-modal/reset-password-modal.component';

interface Props {
  businessId: number;
  customer: ICustomer;
}

export function CustomerUser(props: Props) {

  const {
    businessId,
    customer
  } = props;

  const iconRef = useRef<HTMLDivElement>(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openDetails, setOpenDetails] = useState(false);
  const [openReset, setOpenReset] = useState(false);

  function handleOpenMenu(event?: MouseEvent<HTMLElement>) {
    setOpenMenu(state => !state);
    event?.stopPropagation();
  }

  return (
    <div className={style.container}>
      <Table style={style.table}>
        <TableHeader style={style.tableHeader}>
          <span>Usuario</span>
          <span>Contraseña</span>
          <span></span>
        </TableHeader>
        <tbody>
          <TableRow onClick={() => setOpenDetails(true)}>
            <Cell weight='medium' color='darkgray' text={customer.username}/>
            <Cell weight='medium' color='darkgray' text={customer.password ?? '**************'}/>
            <CellIcon refIcon={iconRef} onClick={handleOpenMenu}/>
          </TableRow>
          <Menu 
            open={openMenu}
            anchor={iconRef}
            style={style.menu}
            top={8}
            onClose={() => setOpenMenu(false)}>
            <MenuOption
              text='Editar'
              onClick={() => setOpenEditModal(true)}/>
            <MenuOption text='Resetear contraseña' onClick={() => setOpenReset(true)}/>
          </Menu>
        </tbody>
      </Table>
      <CustomerModal
        open={openDetails}
        title='Cliente'
        customer={customer}
        onClose={() => setOpenDetails(false)}/>
      <ResetPasswordModal
        open={openReset}
        businessId={businessId}
        customer={customer}
        onReset={() => setOpenDetails(true)}
        onClose={() => setOpenReset(false)}/>
      <EditModal
        open={openEditModal}
        businessId={businessId}
        customer={customer}
        onClose={() => setOpenEditModal(false)}/>
    </div>
  );
}
